import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "input"]

  submit(event) {
    // Disable the submit button
    this.submitTarget.disabled = true

    // Show spinner and update button text
    this.submitTarget.innerHTML = `
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    `

    // Make all form inputs readonly instead of disabled
    this.inputTargets.forEach(input => {
      if (input.type === 'checkbox') {
        // input.disabled = true
      } else {
        input.readOnly = true
      }
    })

    // Also make any other inputs in the form readonly
    const form = this.element
    const allInputs = form.querySelectorAll('input:not([type="hidden"]), select, textarea')
    allInputs.forEach(input => {
      if (input !== this.submitTarget) {
        if (input.type === 'checkbox') {
          // input.disabled = true
        } else {
          input.readOnly = true
        }
      }
    })
  }
}
